import type { FaireProductEntity } from "../../entity_types/product";

export const p_x6jyzjsyk5: FaireProductEntity = {
  token: "p_x6jyzjsyk5",
  type: "product",
  name: "[Dr.Melaxin] Bondex Hair Clinic Shampoo, 400ml",
  brandToken: "b_mjvutrueq2",
  brandName: "K-Beauty Distribution Group",
  imageUrl: "https://cdn.faire.com/fastly/15f667fded9db993329b63b2ea7aaa04813468213bd75416c8346c9a61bb26f4.webp",
  galleryImageUrls: [],
  priceDollars: 22,
  description: "Bondex Bonding Remodeling Line\nHair Restoration | Protein Bonding | Damage Repair\n\nWhat it is:\nUnleash the power of Dr. Melaxin’s Bondex Hair Clinic Line. This innovative duo, featuring the Bondex Hair Clinic Treatment and Shampoo, leverages advanced protein bonding technology and patented ingredients to target severely damaged hair. The line works deeply to repair, rejuvenate, and restore hair, delivering long-lasting, salon-quality results.",
  tags: [],
  msrpDollars: 44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:10.399Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
